import React from 'react';
import {Box, Stack, Typography} from '@mui/material';
import FintelProductRow from './FintelProductRow';

function FintelSection({title, fintels}) {
    return (
        <Box>
            <Typography variant="caption" fontWeight={700} display="block" gutterBottom>
                {title}{fintels.length ? ` (${fintels.length})` : ''}
            </Typography>
            {fintels.length === 0 ? (
                <Typography variant="caption" color="text.secondary">None</Typography>
            ) : (
                <Stack spacing={1}>
                    {fintels.map((fintel) => (
                        <FintelProductRow key={fintel.reportId} fintel={fintel}/>
                    ))}
                </Stack>
            )}
        </Box>
    );
}

/**
 * Analytics pane evidence: Linked FINTELs vs Suggested by Minsky,
 * matching Collection coverage's Linked materials / Suggested by Minsky.
 */
export default function FintelEvidenceSections({fintels = []}) {
    const list = Array.isArray(fintels) ? fintels : [];
    if (list.length === 0) return null;
    const linked = list.filter((fintel) => fintel.linked);
    const suggested = list.filter((fintel) => !fintel.linked);
    return (
        <Stack spacing={2}>
            <FintelSection title="Linked FINTELs" fintels={linked}/>
            <FintelSection title="Suggested by Minsky" fintels={suggested}/>
        </Stack>
    );
}
